type EventData = Record<string, string | number | boolean | undefined | unknown>;

export class DataLayerEvent {
  eventName: string;
  data: EventData;
  objectProperties: EventData;
  protected isGa4Event = true;

  constructor({
    eventName,
    data = {},
    objectProperties = {},
  }: {
    eventName: string;
    data?: EventData;
    objectProperties?: EventData;
  }) {
    this.eventName = eventName;
    this.data = data;
    this.objectProperties = objectProperties;
  }

  toGaObject(): object {
    const eventToPush: any = this.isGa4Event
      ? {
          event: "GAEvent",
          GA4EventName: this.eventName,
        }
      : {};

    let counter = 1;

    Object.entries(this.data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        eventToPush[`GA4InputFieldName${counter}`] = key;
        eventToPush[`GA4InputFieldValue${counter}`] = value;
        counter++;
      }
    });

    Object.entries(this.objectProperties).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      eventToPush[key] = value;
    });

    return eventToPush;
  }

  public static booleanToString(value: boolean | undefined): string | undefined {
    if (value == null) return undefined;
    return value ? "True" : "False";
  }
}
